export default __webpack_public_path__ + "static/media/WarNeighborhood.2b771946.pdf";